module.exports = __webpack_public_path__ + "static/05-699235bc20b596b892dd8d6840ae2f90.jpeg";